var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoginForm)?_c('login-form',{attrs:{"create-link":_vm.createLink},on:{"goToForgotPassword":_vm.toggleForgotPassword}}):_c('password-form',{attrs:{"forgot-password-link":_vm.forgotPasswordLink},on:{"goToLogin":_vm.backToLogin}})
}
var staticRenderFns = []

export { render, staticRenderFns }